/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Button, Link as ChakraLink} from '@salesforce/retail-react-app/app/components/shared/ui'
import {isAbsoluteURL} from '@salesforce/retail-react-app/app/page-designer/utils'
import {convertSfccHrefToPwaHref} from '@consteed/frontend/utils/richTextConfigurations'
import Link from '@consteed/overrides/components/link'
import {NavigateNextIcon} from '@consteed/overrides/components/icons'

/**
 * ConsteedButton
 *
 * @param {object} props
 * @param {string} - props.buttonLink - Button Link.
 * @param {string} - props.buttonText - Button Text.
 * @returns {React.ReactElement} - Button component.
 */
const ConsteedButton = ({buttonLink, buttonText}) => {
    const pwaButtonLink = convertSfccHrefToPwaHref(buttonLink)
    const isAbsolute = isAbsoluteURL(pwaButtonLink)
    const LinkWrapper = isAbsolute ? ChakraLink : Link
    const linkProps = isAbsolute ? {href: pwaButtonLink} : {to: pwaButtonLink}
    return (
        <LinkWrapper {...linkProps}>
            <Button size={'md'} rightIcon={<NavigateNextIcon />} mt={'2rem'}>
                {buttonText}
            </Button>
        </LinkWrapper>
    )
}
ConsteedButton.propTypes = {
    buttonLink: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired
}

export default ConsteedButton
